var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"page page-emergency-inspect-photos"},[_c('detail-photos',{attrs:{"id":_vm.id,"api-name":"emergencyInspectReport"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }